export default {
  "sectors": [
    {
      "id": 1,
      "name": "Agriculture",
      "iconName": "agriculture.svg",
      "count": 3
    },
    {
      "id": 2,
      "name": "Agro-Industry",
      "iconName": "agro.svg",
      "count": 0
    },
    {
      "id": 3,
      "name": "Animal husbandry",
      "iconName": "animal.svg",
      "count": 0
    },
    {
      "id": 4,
      "name": "Aquaculture & Fisheries",
      "iconName": "aquaculture.svg",
      "count": 0
    },
    {
      "id": 5,
      "name": "Automotive",
      "iconName": "automotive.svg",
      "count": 0
    },
    {
      "id": 6,
      "name": "Building materials",
      "iconName": "building.svg",
      "count": 0
    },
    {
      "id": 7,
      "name": "Chemicals",
      "iconName": "chemicals.svg",
      "count": 0
    },
    {
      "id": 8,
      "name": "Communications infrastructure",
      "iconName": "communications.svg",
      "count": 0
    },
    {
      "id": 9,
      "name": "Construction",
      "iconName": "construction.svg",
      "count": 0
    },
    {
      "id": 10,
      "name": "Culture & Arts",
      "iconName": "culture.svg",
      "count": 0
    },
    {
      "id": 11,
      "name": "Education",
      "iconName": "education.svg",
      "count": 0
    },
    {
      "id": 12,
      "name": "Electricity / Energy (IPP)",
      "iconName": "electricity.svg",
      "count": 0
    },
    {
      "id": 13,
      "name": "Electronics",
      "iconName": "electronics.svg",
      "count": 0
    },
    {
      "id": 14,
      "name": "Engineering Services",
      "iconName": "engineering.svg",
      "count": 0
    },
    {
      "id": 15,
      "name": "Entertainment & Media",
      "iconName": "entertainment.svg",
      "count": 0
    },
    {
      "id": 16,
      "name": "Finance & Insurance",
      "iconName": "finance.svg",
      "count": 0
    },
    {
      "id": 17,
      "name": "Food & Dining",
      "iconName": "food_dining.svg",
      "count": 0
    },
    {
      "id": 18,
      "name": "Food processing & Beverages",
      "iconName": "food_processing.svg",
      "count": 0
    },
    {
      "id": 19,
      "name": "Furniture Manufacture",
      "iconName": "furniture.svg",
      "count": 0
    },
    {
      "id": 20,
      "name": "Glass & Glass Products",
      "iconName": "glass.svg",
      "count": 0
    },
    {
      "id": 21,
      "name": "Healthcare",
      "iconName": "healthcare.svg",
      "count": 0
    },
    {
      "id": 22,
      "name": "Hotels & Resorts",
      "iconName": "hotels.svg",
      "count": 0
    },
    {
      "id": 23,
      "name": "Information Technology",
      "iconName": "information.svg",
      "count": 0
    },
    {
      "id": 24,
      "name": "Infrastructure (Utilities)",
      "iconName": "infrastructure.svg",
      "count": 0
    },
    {
      "id": 25,
      "name": "Manufacturing",
      "iconName": "manufacturing.svg",
      "count": 0
    },
    {
      "id": 26,
      "name": "Minerals Processing",
      "iconName": "minerals.svg",
      "count": 0
    },
    {
      "id": 27,
      "name": "Mining & Metals",
      "iconName": "mining_metals.svg",
      "count": 0
    },
    {
      "id": 28,
      "name": "Mining Services",
      "iconName": "mining_services.svg",
      "count": 0
    },
    {
      "id": 29,
      "name": "Oil & Gas: Farm-In",
      "iconName": "oil_farm.svg",
      "count": 2
    },
    {
      "id": 30,
      "name": "Oil & Gas: Licensing Round",
      "iconName": "oil_lic.svg",
      "count": 2
    },
    {
      "id": 31,
      "name": "Packaging",
      "iconName": "packaging.svg",
      "count": 0
    },
    {
      "id": 32,
      "name": "Petrochemicals",
      "iconName": "petrochemicals.svg",
      "count": 0
    },
    {
      "id": 33,
      "name": "Pharmaceutical & Medical",
      "iconName": "pharmaceutical.svg",
      "count": 0
    },
    {
      "id": 34,
      "name": "Real Estate",
      "iconName": "real_estate.svg",
      "count": 0
    },
    {
      "id": 35,
      "name": "Retail",
      "iconName": "retail.svg",
      "count": 0
    },
    {
      "id": 36,
      "name": "Sustainability",
      "iconName": "sustainability.svg",
      "count": 0
    },
    {
      "id": 37,
      "name": "Textile Industries",
      "iconName": "textile.svg",
      "count": 0
    },
    {
      "id": 38,
      "name": "Tourism Opportunities",
      "iconName": "tourism.svg",
      "count": 0
    },
    {
      "id": 39,
      "name": "Transport Infrastructure",
      "iconName": "transport.svg",
      "count": 0
    }
  ]
}